import { Arc as ArcLayout } from '../data/utils/arc';
/**
 * For arc diagram(edge with weight) or chord diagram(with weight)
 */
export var Arc = function Arc(options) {
  return function (data) {
    return ArcLayout(options)(data);
  };
};
Arc.props = {};